import emitter from '../../modules/emitter.js';

// Init new emitter
const mproEmitter = emitter();

/**
 * Expose the emit api
 */
mpro.emit = mproEmitter.emit;
mpro.on = mproEmitter.on;
// @ts-ignore
mpro.once = mproEmitter.once;
mpro.off = mproEmitter.off;

export default mpro;
